import { AsyncPipe, SlicePipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DiscoverFacade } from '@zero/discover/domain';
import { commonRoutes } from 'constants/web-app-constants';
import { environment } from 'environments/environment';

@Component({
  selector: 'etfs-strategies',
  imports: [AsyncPipe, SlicePipe, RouterLink],
  templateUrl: './strategies.component.html',
  styleUrl: './strategies.component.scss',
})
export class StrategiesComponent implements OnInit {
  public readonly discoverFacade = inject(DiscoverFacade);
  public readonly url = commonRoutes.postlogin.multi_order_strategies;
  public readonly imageBase = environment.assetshost;

  ngOnInit(): void {
    this.discoverFacade.loadMultiOrderStrategies('etfSavingsPlansTeaser');
  }
}
